(function($) {
    $.fn.slidingFeaturedImageGroup = function() {
        this.each(function() {
            var $this = $(this),

                setupAriaLabelOnSlide = function() {
                    $this.on('init reInit afterChange', function() {
                        var suFeaturedSlide = $this.find('.slick-current .su-featured-image-slide'),
                            imgAlt = suFeaturedSlide.find('img').attr('alt');
                        $this.find(suFeaturedSlide).attr('aria-label', imgAlt);
                    });
                },

                startSlider = function() {
                    var previous = $().isWelshPage() ? 'Blaenorol' : 'Previous',
                        next     = $().isWelshPage() ? 'Nesaf' : 'Next';

                    $this.slick({
                        prevArrow: `<button class="slick-prev" aria-label="${previous}" type="button">${previous}</button>`,
                        nextArrow: `<button class="slick-next" aria-label="${next}" type="button">${next}</button>`,
                        dots: true,
                        autoplay: true,
                        speed: 100,
                        autoplaySpeed: 5000,
                        fade: true,
                        cssEase: 'linear',
                        adaptiveHeight: true,
                        accessibility: true
                    });
                },

                setUpPlayPauseButton = function() {
                    $.fn.clickToggle = function(func1, func2) {
                        var funcs = [func1, func2];
                        this.data('toggleclicked', 0);
                        this.click(function() {
                            var data = $(this).data(),
                                tc = data.toggleclicked;
                            $.proxy(funcs[tc], this)();
                            data.toggleclicked = (tc + 1) % 2;
                        });
                        return this;
                    };

                    $this.siblings('.pause-play-carousel').clickToggle(function() {
                        var ariaLabelPlay = $(this).data('aria-label-play');
                        $this.slick('slickPause');
                        $(this).attr('aria-label', ariaLabelPlay).find('.fa-solid').removeClass('fa-pause').addClass('fa-play');
                    }, function() {
                        var ariaLabelPause = $(this).data('aria-label-pause');
                        $this.slick('slickPlay');
                        $(this).attr('aria-label', ariaLabelPause).find('.fa-solid').removeClass('fa-play').addClass('fa-pause');
                    });
                };

            setupAriaLabelOnSlide();
            startSlider();
            setUpPlayPauseButton();
        });
        return this;
    };
}(jQuery));
